<template>
  <el-dialog
    title="上传模型"
    :visible.sync="innerVisible"
    width="520px"
    @closed="resetForm"
  >
    <el-form :model="form" label-width="96px" size="small">
      <el-form-item label="模型名称">
        <el-input v-model="form.name" placeholder="留空则用文件名" clearable />
      </el-form-item>
      <el-form-item label="权重类型" required>
        <el-radio-group v-model="form.weight_type">
          <el-radio label="base">基础权重</el-radio>
          <el-radio label="product">训练产物</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="类别名">
        <el-input v-model="form.class_names" placeholder="逗号分隔，如 person,car" clearable />
      </el-form-item>
      <el-form-item label="权重文件">
        <el-upload
          ref="upload"
          accept=".pt"
          :auto-upload="false"
          :limit="1"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :file-list="form.fileList"
        >
          <el-button size="small" icon="el-icon-folder-opened">选择文件</el-button>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="small" @click="innerVisible = false">取消</el-button>
      <el-button
        type="primary"
        size="small"
        :loading="uploading"
        :disabled="!form.file || !form.weight_type"
        @click="handleUpload"
      >上传</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { uploadModel } from '../api/blissrose/inference';

// 类型只有 yolo 一种，不设选择项
const DEFAULT_FORM = {
  name: '',
  model_type: 'yolo',
  class_names: '',
  weight_type: '',
  file: null,
  fileList: [],
};

/** 模型权重上传对话框：基础权重与训练产物都收；只收 .pt，服务端也卡后缀 */
export default {
  name: 'ModelUploadDialog',

  props: {
    visible: { type: Boolean, default: false },
  },

  data() {
    return {
      uploading: false,
      form: { ...DEFAULT_FORM },
    };
  },

  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },

  methods: {
    /** 选中即校验后缀，当场给反馈；accept 只是过滤提示，真正的门在服务端 */
    handleFileChange(file) {
      if (!/\.pt$/i.test(file.name || '')) {
        this.$message.error('只接受 .pt 权重文件');
        this.form.file = null;
        this.form.fileList = [];
        if (this.$refs.upload) this.$refs.upload.clearFiles();
        return;
      }
      this.form.file = file.raw;
      this.form.fileList = [file];
    },

    handleFileRemove() {
      this.form.file = null;
    },

    resetForm() {
      this.form = { ...DEFAULT_FORM };
    },

    async handleUpload() {
      this.uploading = true;
      try {
        const record = (await uploadModel(this.form.file, {
          name: this.form.name,
          model_type: this.form.model_type,
          class_names: this.form.class_names,
          weight_type: this.form.weight_type,
        })).data;
        this.$message.success('模型已上传');
        this.innerVisible = false;
        this.$emit('uploaded', record);
      } catch (err) {
        // 错误提示由响应拦截器统一弹出
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
